<template>
	<div class="access-list">
		<div class="access-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Access Solutions</span>
			</div>

			<div class="list">
				<ul>
					<li>
						<img class="x-flow" :src="solution_image_01" alt="Xhorse"/>
						<div class="tt x-flow">
							<div class="hh">Intelligent Access Control System</div>
							<p class="txt">
								The access system supports four identity recognition solutions: face recognition, fingerprint recognition, password recognition, and IC card recognition. The identity recognition supports the tailoring function. Multiple combinations of identification methods can be chosen based on users’ needs. The system also provides more useful solutions such as online and offline working mode; recording identity access data; anti-pinch function; access authority management; fire safety interface, and emergency switch function.</p>
						</div>
					</li>

					<li>
						<img class="x-flow" :src="solution_image_02" alt="Xhorse"/>
						<div class="tt x-flow">
							<div class="hh" style="margin-top: 24px">Smart Electronic Lock</div>
							<p class="txt">
								The Smart Electronic Lock supports fingerprint recognition, password-protected door locking system, WiFi connection, access information record function, and system information configuration. It enables you to remotely open your door by using the cell phone App. The smart electronic lock also has a power detection function, which will prompt you to replace the battery when the power is too low.</p>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_accss_01.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_accss_02.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02
            };
        }
    }

</script>

<style scoped="">

	.tt > .hh {
		font-size: 1rem;
		color: #3B3A38;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.75rem;
		margin-bottom: .75rem;
	}

	.tt > .txt {
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
	}

	.list > ul > li > .tt {
		width: calc(100% - 20.125rem - 2rem);
		text-align: center;
		height: 18rem;
		margin-left: 2rem;
	}

	.list > ul > li > img {
		height: 18rem;
	}

	.list > ul > li:last-child {
		padding-top: 4rem;
	}

	.list > ul > li:first-child {
		border-bottom: 1px solid #D7D7D7;
	}

	.list > ul > li {
		width: 100%;
		height: 22rem;
		border: none;
	}

	.list > ul {
		width: 100%;
		height: 44.0625rem;
		border: none;
	}

	.list {
		width: 54.5rem;
		height: 44.0625rem;
		margin-left: 7rem;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.access-con {
		width: 61.5rem;
		height: 60.5625rem;
		border: none;
		margin-left: 0px;
	}

	.access-list {
		width: 100%;
		height: 60.5625rem;
		border: none;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}

	.warnning {

		width: 100%;
		height: 100px;
		margin: 0 auto;
		text-align: center;
		font-style: oblique;
		font-size: 4rem;
		font-family: "Open Sans";
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;

	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-access.vue